<loading></loading>
<!-- TODO: uncomment navigation when auth is ready
@if (auth.isAuthenticated$ | async){
<app-navigation kendoRippleContainer></app-navigation>
} -->
<app-navigation kendoRippleContainer></app-navigation>
<div kendoDialogContainer></div>
